import useNavigation from "../../common/useNavigation"
import { Link, Invitations, Logo, Notification, Upgrade, useEffect, useState, FaPowerOff, Axios } from '../../common/common';
import { Button, ButtonGroup } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { IoMdClose } from "react-icons/io";
import { showToast } from "../../Utils/toastUtils";
import axiosJWT from "../../secureAPI/axiosJWT";
// import notification1 from "../../assets/images/notification1.svg";
// import notification2 from "../../assets/images/notification2.svg";
// import notification3 from "../../assets/images/notification3.svg";
// import notification4 from "../../assets/images/notification4.svg";




const Topbar = (props) => {
    const navigate = useNavigate();
    const userTypes = props.UserTypeData || ""; // Default to empty string if undefined
    const usertypeArray = userTypes
        .split(',')
        .map(str => parseInt(str.trim()))
        .filter(num => !isNaN(num)); // Clean and convert to numbers

    const hasOne = usertypeArray.includes(1);
    // const hasTwo = usertypeArray.includes(2);
    const hasOneAndTwo = [1, 2].every(num => usertypeArray.includes(num));

    const currentUserType = props.currentUserType;

    const { navigateDashboard, navigatePlans } = useNavigation();
    const [time, setTime] = useState();
    // const [isLoading, setIsLoading] = useState(false);
    // const [isDisabled, setIsDisabled] = useState(false);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(true);
    const [notifications, setNotifications] = useState([
        // {
        //     id: 1,
        //     category: "New Messages",
        //     content: "Jane Sam sent you a message.",
        //     time: "Now",
        //     icon: notification1,
        //     read: false
        // },
        // {
        //     id: 2,
        //     category: "Order Updates",
        //     content: "Order #54321 has been shipped.",
        //     time: "2 hours ago",
        //     icon: notification2,
        //     read: false
        // },
        // {
        //     id: 3,
        //     category: "Comment on Post",
        //     content: "Reacted: John Richard on your next p...",
        //     time: "2 hours ago",
        //     icon: notification3,
        //     read: true
        // },
        // {
        //     id: 4,
        //     category: "Follow Request",
        //     content: "Kelin Brown has sent you the request.",
        //     time: "1 Day ago",
        //     icon: notification4,
        //     read: true
        // }
    ]);
    const unreadNotificationCount = notifications.filter(n => !n.read).length;

    const toggleNotificationPanel = () => {
        setShowNotificationPanel(!showNotificationPanel);
        if (hasUnreadNotifications) {
            setHasUnreadNotifications(false);
        }
    };

    const closeNotificationPanel = () => {
        setShowNotificationPanel(false);
    };

    const removeNotification = (id) => {
        setNotifications(notifications.filter(notification => notification.id !== id));
    };
    const logout = async () => {
        await Axios.post(`${process.env.REACT_APP_API_URL}/api/LogOut`,{},{ withCredentials: true });
        window.location.href = "/";
        // window.location.reload();
        // navigate("/")
    };

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    useEffect(() => {
        // refreshToken();
        showToast('', '');
        const timer = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return (
        <div className="border-b-2 border-solid border-[#e5e5e5] h-[70px]">
            <div className="lg:hidden flex justify-between items-center bg-gray-100 px-4 py-2">
                {/* Logo Centered */}
                <div className="flex-1 flex justify-center">
                    <img className="text-xl font-bold text-gray-800" width={80} src={Logo} alt="Logo" />
                </div>

                {/* Kebab menu at right */}
                <div className="relative">
                    <button
                        id="kebab-menu"
                        className="text-gray-700"
                        onClick={toggleMenu}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                            />
                        </svg>
                    </button>

                    {isMenuOpen && (
                        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                            <Link
                                to="/switch-to-buyer"
                                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                Switch To Buyer Account
                            </Link>
                            <Link
                                to="/notifications"
                                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                Notifications
                            </Link>
                            <Link
                                to="/upgrade-plans"
                                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                Upgrade Plans
                            </Link>
                            <button
                                onClick={logout}
                                className="w-full text-left block px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>


            {/* // <div className={`${props.issidebarOpen ? "" : "pl-2"} flex flex-row  rounded-b-md  overflow-x-hidden   bg-white border-2 border-solid border-[#e5e5e5]  sticky top-0 h-18 items-center justify-between  z-[1]  `} > */}
            <div className="float-left px-2 hidden lg:block ">
                <div className="relative  p-2 w-full rounded-md   ">
                    <ButtonGroup className="mb-2">
                        {/* Main Button showing logged in as type */}
                        {/* linear-gradient(45deg, #d8f2e6, #a3f7d1) */}
                        <Button
                            className={`
      ${(hasOneAndTwo && currentUserType.toLowerCase() === 'seller')
                                    ? '!bg-gradient-to-r from-[#d8f2e6] to-[#a3f7d1] !text-[#4b2402]'
                                    : ((hasOne || hasOneAndTwo) && currentUserType.toLowerCase() === 'buyer')
                                        ? 'bg-gradient-to-r from-[#21a8ed] to-[#025883]'
                                        : (hasOne && (currentUserType.toLowerCase() === 'seller' || currentUserType.toLowerCase() === 'buyer'))
                                            ? 'bg-gradient-to-r from-[#21a8ed] to-[#025883]'
                                            : null
                                }
      !font-semibold uppercase border-0
    `}
                        >
                            Logged in as {
                                (hasOneAndTwo && currentUserType.toLowerCase() === 'seller') ? 'Seller'
                                    : (hasOne && currentUserType.toLowerCase() === 'buyer') ? 'Buyer'
                                        : ((hasOne || hasOneAndTwo) && (currentUserType.toLowerCase() === 'buyer' || currentUserType.toLowerCase() === 'seller'))
                                            ? 'Buyer'
                                            : null
                            }
                        </Button>

                        {/* Conditional Button to switch login state */}
                        {hasOneAndTwo && (
                            <Button
                                className="btn btn-secondary !bg-[#ededed] !text-[#4f4f4f] text-sm !font-semibold rounded-full border-0"
                                onClick={() => {
                                    if (hasOne || hasOneAndTwo) {
                                        if (currentUserType.toLowerCase() === 'seller') {
                                            navigateDashboard('buyer');
                                        } else if (currentUserType.toLowerCase() === 'buyer') {
                                            navigateDashboard('seller');
                                        }
                                    }
                                }}
                            >
                                Click to Log in as {
                                    (hasOneAndTwo && currentUserType.toLowerCase() === 'seller')
                                        ? 'Buyer'
                                        : (hasOneAndTwo && currentUserType.toLowerCase() === 'buyer')
                                            ? 'Seller'
                                            : null
                                }
                            </Button>
                        )}
                    </ButtonGroup>

                </div>
            </div>

            <div className="hidden lg:flex flex-row justify-end float-right ">
                {/* notification start  */}
                <div className="relative">
                    <div
                        className="border-l-2 bg-[#e5e5e5] lg:bg-[#ffffff] rounded-full lg:rounded-none cursor-pointer w-[50px] h-[50px] lg:w-auto lg:h-auto lg:p-1.5"
                        onClick={toggleNotificationPanel}
                    >
                        <div className="flex flex-col text-center lg:flex-row text-[#002080] lg:text-left text-xs font-bold">
                            <div className="relative">
                                <img
                                    className="animate-vibrate"
                                    src={Notification}
                                    width={20}
                                    height={20}
                                    alt="Notifications"
                                />
                                {hasUnreadNotifications && unreadNotificationCount > 0 && (
                                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                                        {unreadNotificationCount}
                                    </span>
                                )}
                            </div>
                            <div className="pl-2 hidden lg:block ">Notifications</div>
                        </div>
                        <div className="pl-7 text-xs hidden lg:block text-gray-500 font-semibold">
                            New update available <br /> click to view details
                        </div>
                    </div>

                    {showNotificationPanel && (
                        <div className="absolute left-0 mt-2 w-80 bg-white rounded-md shadow-lg z-50">
                            <div className="p-4 border-b">
                                <div className="flex justify-between items-center">
                                    <h3 className="font-bold text-gray-600">Notifications</h3>
                                    <button onClick={closeNotificationPanel} className="text-gray-500 text-sm hover:text-gray-600">
                                        clear all
                                    </button>
                                </div>
                                <div className="text-sm font-medium text-gray-500 mt-1">
                                    {unreadNotificationCount} Unread
                                </div>
                            </div>

                            {notifications.length === 0 ? (
                                <div className="p-4 text-center font-bold text-gray-500">
                                    No New Notifications
                                </div>
                            ) : (
                                <div className="max-h-80 overflow-y-auto">
                                    {notifications.map((notification) => (
                                        <div
                                            key={notification.id}
                                            className={`p-3 border-b ${!notification.read ? 'bg-blue-50' : ''}`}
                                        >
                                            <div className="flex justify-between items-start">
                                                <div className="flex-1 flex gap-3">
                                                    <img
                                                        className="nav-logo-icon cursor-pointer"
                                                        src={notification.icon}
                                                        width="48"
                                                        height="48"
                                                        alt={notification.icon}
                                                    />
                                                    <div>
                                                        <div className="font-bold text-sm text-gray-500">
                                                            {notification.category}
                                                        </div>
                                                        <div className="text-sm text-gray-500">
                                                            {notification.content}
                                                        </div>
                                                        <div className="text-xs text-gray-500 mt-1">
                                                            {notification.time}
                                                        </div>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => removeNotification(notification.id)}
                                                    className="text-gray-400 hover:text-gray-600 ml-2"
                                                >
                                                    <IoMdClose />
                                                </button>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="p-3 text-center !bg-gradient-to-r from-theme-color-start to-theme-color-end rounded-b-md hover:bg-blue-700 border-t cursor-pointer">
                                <button className="text-[#4b2402] text-sm font-semibold">View All</button>
                            </div>
                        </div>
                    )}
                </div>
                {/* notification end  */}



                <div className=" border-l-2 bg-[#e5e5e5] lg:bg-[#ffffff] rounded-full lg:rounded-none cursor-pointer w-[50px] h-[50px]  lg:w-auto lg:h-auto lg:p-1.5">
                    <div className="flex flex-col text-center  lg:flex-row  text-[#002080] lg:text-left text-xs font-bold">
                        <img className="" src={Invitations} width={20} height={20} alt="Dasahboard" />
                        <div className="pl-2 hidden lg:block">Invite </div>
                    </div>
                    <div className="  pl-7 text-xs hidden lg:block font-semibold text-gray-500">
                        Send invites and unlock <br /> exclusive rewards.
                    </div>
                </div>

                {currentUserType === "seller" &&
                    <div className=" border-l-2 bg-[#e5e5e5] lg:bg-[#ffffff] rounded-full lg:rounded-none  cursor-pointer  w-[50px] h-[50px]  lg:w-auto lg:h-auto lg:p-1.5"
                        onClick={() => { navigatePlans(currentUserType) }}
                    >
                        <div className="flex flex-col text-center  lg:flex-row  text-[#002080] lg:text-left text-xs font-bold">
                            <img src={Upgrade} width={20} height={20} alt="Dasahboard" />
                            <div className="pl-2 hidden lg:block">Upgrade your plan </div>
                        </div>
                        <div className="pl-7  text-xs hidden lg:block text-gray-500 font-semibold">
                            Upgrade your regular plan <br /> to advanced plan{" "}
                        </div>
                    </div>
                }


                <div className="lg:flex hidden space-x-2 items-center px-4 py-2 p-5 bg-[#ccffff]  text-[#002080] text-md font-bold">
                    {time}
                </div>
                <div className="lg:flex block  items-center bg-[#F34235]  rounded-full  text-md font-bold cursor-pointer  p-4 lg:w-auto lg:m-auto" onClick={() => logout()} >
                    <FaPowerOff className="text-white    " />
                </div>
            </div>
        </div>
    )
}

export default Topbar